import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import {
  DateRangePicker,
  GuestPicker,
  HotelLocationAutocomplete,
  useHotelSearch,
} from "@tenant/hotels";
import clsx from "clsx";
import defaultStyles from "./HotelSearch.module.scss";

export type HotelSearchComponentProps = PlatformComponentProps;
export const HotelSearch = ({
  children,
  className,
}: HotelSearchComponentProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.HotelSearch;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { context, handlers } = useHotelSearch();

  return (
    <div className={clsx(block, className)}>
      <form className={cn("form")} onSubmit={handlers.onFormSubmit}>
        <HotelLocationAutocomplete
          label={context.locationLabel}
          value={context.place}
          onChange={handlers.handlePlaceChange}
          id={"hotel-location-autocomplete"}
        />
        <DateRangePicker
          startDate={context.dateRange?.from}
          endDate={context.dateRange?.until}
          onStartDateChangeHandler={(date) => {
            handlers.handleDateRangeFromChange(date);
          }}
          onEndDateChangeHandler={(date) => {
            handlers.handleDateRangeUntilChange(date);
          }}
        />
        <GuestPicker
          onGuestSelectionHandler={handlers.handleGuestsChange}
          guests={context.guests}
          rooms={context.roomsCount}
          onRoomsSelectionHandler={handlers.handleRoomsCountChange}
        />
        <button
          className={cn("search-button")}
          type="submit"
          disabled={!context.isFormValid}
        >
          {context.searchButtonLabel}
        </button>
        {children}
      </form>
    </div>
  );
};
